module.exports = __webpack_public_path__ + "static/img/ico_user.c3631c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/ico_user.png
// module id = 3Ylt
// module chunks = 1